var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader-wrapper has-background-primary"},[_c('div',{staticClass:"preloader"},[_c('span',{staticClass:"icon has-text-white"},[_c('font-awesome-icon',{attrs:{"spin":"","icon":['fal', 'spinner-third'],"size":"6x"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }